import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL caseS
export const caseList = (params = '') => Http.get(`/marketing-cases${serialize(params)}`)
export const caseCreate = (params = '') => Http.post('/marketing-cases', params)
export const caseByID = (params = '') => Http.get(`/marketing-cases/${params}?include=countries,results,deliverables,influencers,assets,campaign_category,campaign_type,case_type,language,kpis,game,company`)
export const caseUpdate = (params = '') => Http.put(`/marketing-cases/${params.id}`, params)
export const caseDestroy = (params = '') => Http.delete(`/marketing-cases/${params.id}`)

// Re-pull deliverables/results/kpis/assets/headline_metrics from the source campaign order —
// coverage/push-notification data added after the case was first exported doesn't auto-sync.
export const caseResyncFromCampaign = (id) => Http.post(`/marketing-cases/${id}/resync-from-campaign`)
